import { Routes } from '@angular/router';
import { ErrorComponent } from '@features/error/error.component';
import { CheckoutClinngVoucherComponent } from '@features/checkout-clinng-voucher/checkout-clinng-voucher.component';

export const routes: Routes = [
  {
    path: 'voucher/:merchantId/:operationId',
    component: CheckoutClinngVoucherComponent,
  },
  {
    path: 'error/:id',
    component: ErrorComponent,
  },
  {
    path: 'error-status/:id',
    component: ErrorComponent,
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];
